import { Component, Input } from '@angular/core';
import { IconType } from '@ng-icons/core';

export interface ResultButton {
  id?: string,
  name?: string,
  label: string,
  /** Omit when using externalHref (link renders as <a>). */
  onClick?: () => void,
  icon?: IconType,
  counter?: number,
  disabled?:boolean
  show?: boolean
  tooltip?: string
  /** When set, renders as an anchor (external link) instead of mot-button. */
  externalHref?: string;
  /**
   * a11y: visually-hidden supplementary hint rendered INSIDE the <a> after the
   * visible label (e.g. ", external website, opens in a new tab"). MUST NOT
   * be set as aria-label — the <a>'s role "link" is auto-announced by screen
   * readers, and combining aria-label with visible text + role causes a
   * duplicated "link ... link" announcement on iOS/Android.
   */
  externalLinkHint?: string;
  /** e.g. `'dialog'` when onClick opens a modal dialog. */
  ariaHaspopup?: string;
  /** Full accessible name when visible label is split from supplementary text (e.g. message count badge). */
  ariaLabel?: string;
}

@Component({
    selector: 'app-detailed-result-buttons',
    templateUrl: './detailed-result-buttons.component.html',
    styleUrls: ['./detailed-result-buttons.component.scss'],
    standalone: false
})
export class DetailedResultButtonsComponent {
  @Input() buttons: ResultButton[] = [];
  /**
   * a11y: when true, the first action button/link is marked cdkFocusInitial so
   * the slide-up focus trap lands on the top row of result actions (not a form field).
   */
  @Input() focusInitialOnFirst = false;
}
